/*
  Size calculator + purchase block
  ----------------------------------
  Everything you're likely to want to tweak lives in JS_CONFIG below.

  IMPORTANT: JS_CONFIG.tiers must match the automatic quantity discount
  you have configured in Shopify Admin > Discounts. This script only
  calculates what to DISPLAY. It does not create the discount. If you
  change a percentage here, change it in Shopify Admin too.
*/

var JS_CONFIG = {
  tiers: [
    { minSets: 1, discount: 0 },
    { minSets: 2, discount: 0.05 },
    { minSets: 3, discount: 0.15 },
    { minSets: 4, discount: 0.25 }
  ]
};

function initAllCalculators(root) {
  (root || document).querySelectorAll('.sc-block:not([data-sc-initialized])').forEach(function (el) {
    el.setAttribute('data-sc-initialized', 'true');
    initCalculator(el);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initAllCalculators(document);
});

// Jeres tema genindlæser produkt-info-sektionen via AJAX ved fx farveskift,
// hvilket bytter HTML'en ud uden at DOMContentLoaded fyrer igen. Denne
// observer opdager når en ny .sc-block dukker op i DOM'en og starter den.
var scObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (node.nodeType !== 1) return;
      if (node.matches && node.matches('.sc-block')) {
        initAllCalculators(node.parentNode || document);
      } else if (node.querySelector) {
        initAllCalculators(node);
      }
    });
  });
});

if (document.body) {
  scObserver.observe(document.body, { childList: true, subtree: true });
} else {
  document.addEventListener('DOMContentLoaded', function () {
    scObserver.observe(document.body, { childList: true, subtree: true });
  });
}

function initCalculator(root) {
  var dataEl = root.querySelector('[data-sc-product-data]');
  if (!dataEl) return;
  var product = JSON.parse(dataEl.textContent);

  var state = {
    mode: 'spread',
    unit: 'metric',
    recommendedSets: 1,
    manualSets: null
  };

  var els = {
    modeButtons: root.querySelectorAll('[data-mode]'),
    unitButtons: root.querySelectorAll('[data-unit]'),
    panels: root.querySelectorAll('[data-mode-panel]'),
    widthInput: root.querySelector('[data-sc-input="width"]'),
    heightInput: root.querySelector('[data-sc-input="height"]'),
    lengthInput: root.querySelector('[data-sc-input="length"]'),
    suffixesLength: root.querySelectorAll('[data-sc-suffix="length"]'),
    recommendation: root.querySelector('[data-sc-recommendation]'),
    tiersWrap: root.querySelector('[data-sc-tiers]'),
    addToCartBtn: root.querySelector('[data-sc-add-to-cart]'),
    quantityInput: root.querySelector('[data-sc-quantity-input]')
  };

  els.modeButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.mode = btn.getAttribute('data-mode');
      state.manualSets = null;
      els.modeButtons.forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      });
      els.panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-mode-panel') !== state.mode;
      });
      recalculate();
    });
  });

  els.unitButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.getAttribute('data-unit') === state.unit) return;
      toggleUnit(btn.getAttribute('data-unit'));
      els.unitButtons.forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });
    });
  });

  [els.widthInput, els.heightInput, els.lengthInput].forEach(function (input) {
    if (!input) return;
    input.addEventListener('input', function () {
      state.manualSets = null;
      recalculate();
    });
  });

  function toggleUnit(newUnit) {
    var CM_PER_INCH = 2.54;
    [els.widthInput, els.heightInput, els.lengthInput].forEach(function (input) {
      if (!input || input.value === '') return;
      var v = parseFloat(input.value);
      input.value = newUnit === 'imperial'
        ? round2(v / CM_PER_INCH)
        : round2(v * CM_PER_INCH);
    });
    els.suffixesLength.forEach(function (s) { s.textContent = newUnit === 'imperial' ? 'inch' : 'cm'; });
    state.unit = newUnit;
    recalculate();
  }

  function recalculate() {
    var calculatedSets;
    if (state.mode === 'border') {
      var lengthM = toMetersArea(parseFloat(els.lengthInput ? els.lengthInput.value : 0) || 0);
      var setsPerMeter = product.setsPerMeter || 0;
      calculatedSets = Math.ceil(lengthM * setsPerMeter);
    } else {
      var widthM = toMetersArea(parseFloat(els.widthInput ? els.widthInput.value : 0) || 0);
      var heightM = toMetersArea(parseFloat(els.heightInput ? els.heightInput.value : 0) || 0);
      var areaSqm = widthM * heightM;
      var setsPerSqm = product.setsPerSqm || 0;
      calculatedSets = Math.ceil(areaSqm * setsPerSqm);
    }
    calculatedSets = Math.max(1, calculatedSets);
    state.calculatedSets = calculatedSets;

    var selectedSets = state.manualSets || calculatedSets;
    state.recommendedSets = selectedSets;

    els.recommendation.textContent = calculatedSets + ' ' + product.labels.setsWord;
    renderTiers(selectedSets, calculatedSets);
    if (els.addToCartBtn) {
      els.addToCartBtn.textContent = product.labels.addToCart.replace('XX', selectedSets);
    }
    if (els.quantityInput) {
      els.quantityInput.value = selectedSets;
    }
  }

  function toMetersArea(value) {
    // Spredt- og bort-tilstand bruger samme enheder nu: cm eller inch
    return state.unit === 'imperial' ? value * 0.0254 : value / 100;
  }

  function renderTiers(selectedSets, calculatedSets) {
    els.tiersWrap.innerHTML = '';
    JS_CONFIG.tiers.forEach(function (tier, i) {
      var next = JS_CONFIG.tiers[i + 1];
      var isTopTier = !next;
      var label = next ? tier.minSets + ' ' + product.labels.setsWord : tier.minSets + '+ ' + product.labels.setsWord;
      var isSelected = isTopTier
        ? selectedSets >= tier.minSets
        : selectedSets === tier.minSets;

      var qtyForRow = isSelected ? selectedSets : tier.minSets;
      var totalPrice = product.price * qtyForRow * (1 - tier.discount);
      var discountLabel = tier.discount > 0 ? ' · ' + product.labels.save + ' ' + Math.round(tier.discount * 100) + '%' : '';

      function applyQty(newQty) {
        newQty = Math.max(tier.minSets, newQty || tier.minSets);
        state.manualSets = newQty;
        state.recommendedSets = newQty;
        els.recommendation.textContent = state.calculatedSets + ' ' + product.labels.setsWord;
        renderTiers(newQty, state.calculatedSets);
        if (els.addToCartBtn) {
          els.addToCartBtn.textContent = product.labels.addToCart.replace('XX', newQty);
        }
        if (els.quantityInput) {
          els.quantityInput.value = newQty;
        }
      }

      if (isTopTier) {
        var row = document.createElement('div');
        row.className = 'sc-tier-row sc-tier-row-stepper' + (isSelected ? ' is-recommended' : '');
        row.innerHTML =
          '<span>' + label + discountLabel + '</span>' +
          '<span class="sc-tier-right">' +
            '<span class="sc-stepper">' +
              '<button type="button" class="sc-stepper-btn" data-step="-1" aria-label="Færre">−</button>' +
              '<input type="number" min="' + tier.minSets + '" value="' + qtyForRow + '" class="sc-stepper-input">' +
              '<button type="button" class="sc-stepper-btn" data-step="1" aria-label="Flere">+</button>' +
            '</span>' +
            '<span class="sc-tier-price">' + formatMoney(totalPrice, product.locale, product.currency) + '</span>' +
          '</span>';
        var input = row.querySelector('.sc-stepper-input');
        row.addEventListener('click', function () {
          applyQty(tier.minSets);
        });
        row.querySelectorAll('.sc-stepper-btn').forEach(function (b) {
          b.addEventListener('click', function (e) {
            e.stopPropagation();
            var delta = parseInt(b.getAttribute('data-step'), 10);
            applyQty((parseInt(input.value, 10) || tier.minSets) + delta);
          });
        });
        input.addEventListener('click', function (e) { e.stopPropagation(); });
        input.addEventListener('change', function () {
          applyQty(parseInt(input.value, 10));
        });
        els.tiersWrap.appendChild(row);
      } else {
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'sc-tier-row' + (isSelected ? ' is-recommended' : '');
        row.innerHTML =
          '<span>' + label + discountLabel + '</span>' +
          '<span>' + formatMoney(totalPrice, product.locale, product.currency) + '</span>';
        row.addEventListener('click', function () {
          applyQty(tier.minSets);
        });
        els.tiersWrap.appendChild(row);
      }
    });
  }

  function round2(n) {
    return Math.round(n * 100) / 100;
  }

  recalculate();
}

function formatMoney(cents, locale, currency) {
  try {
    return new Intl.NumberFormat(locale || 'da-DK', {
      style: 'currency',
      currency: currency || 'DKK',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(cents / 100);
  } catch (e) {
    return (cents / 100) + ' ' + (currency || '');
  }
}